export default "__VITE_ASSET__BOn1PZSQ__"